import { noop } from 'es-toolkit/compat';

import { Navigation } from 'types';
import AppConstants from 'constants/AppConstants';

const initialState: Navigation = {
  title: '',
  titleLeft: '',
  hasLogo: false,
  hasBack: false,
  hasCityPicker: false,
  goBackTo: '',
  fixedPosition: true,
  hasClose: false,
  onClose: noop,
  isBusinessProfile: false,
};

export default function reducer(
  state: Navigation = initialState,
  action: BaseTockAction
): Navigation {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.NAVIGATION_SET: {
      return {
        // Really, this should read ...state,
        // but much code around this has grown up around the notion that this call
        // really has _reset_ rather than _update_ semantics. :-/
        ...initialState,
        ...payload,
      };
    }
    // Use this action when you really want an incremental update to navigation, preserving
    // non-mentioned keys at their current value.
    case AppConstants.NAVIGATION_INCREMENTAL_UPDATE: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
}
